module.exports = __webpack_public_path__ + "img/service_img4.26398662.png";